var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-1",
    attrs: { headers: _vm.headers, items: _vm.seguimiento_detalles },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function(props) {
          return [
            _c("td", { staticClass: "text-xs-center" }, [
              _vm._v(
                _vm._s(
                  _vm.$moment(props.item._created_at).format("DD/MM/YYYY HH:mm")
                ) + " "
              )
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-xs-center" }, [
              _vm._v(_vm._s(props.item.estado.descripcion))
            ]),
            _vm._v(" "),
            _c("td", { staticClass: "text-xs-center" }, [
              _vm._v(
                _vm._s(props.item.persona.nombres) +
                  " " +
                  _vm._s(props.item.persona.ap_paterno) +
                  " " +
                  _vm._s(props.item.persona.ap_materno)
              )
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5785d16d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5785d16d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/permiso/components/SeguimientoDetalle.vue
// module id = null
// module chunks = 